<template>
    <div id="categoryPage">
        <modal name="m-filters" class="filters-modal">
            <mobile-filters :organicp="toggleOrganic" :glutenp="toggleGlutenFree" :salep="toggleSale"></mobile-filters>
        </modal>
        <section
            class="category_top_banner s_cat_in_top_banner cover"
            v-bind:style="[
                subCategory.thumb
                    ? { backgroundImage: 'url(' + subCategory.thumb + ')' }
                    : { backgroundImage: 'url(' + mainCategory.thumb + ')' },
            ]"
        >
            <div class="container">
                <h2 class="title">{{ mainCategory.name }}</h2>
                <div class="text">{{ mainCategory.description }}</div>
            </div>
            <div class="bn_corner"></div>
        </section>
        <div class="mobile_only m_cat_tabs">
            <Slick class="m_cat_tabs_slide clearfix" ref="slick" :options="mSlickOptions">
                <div
                    class="right m_cat_tab"
                    v-bind:class="{ active: subcat.id == subCategory.id }"
                    v-for="subcat in subCategories"
                    :key="subcat.id"
                >
                    <router-link :to="{ path: subcat.link }" v-bind:data-subid="subcat.id">
                        <span class="table100">
                            <span class="table_cell">{{ subcat.name }}</span>
                        </span>
                    </router-link>
                </div>
            </Slick>
            <div class="fade-side"></div>
            <div class="m_filter_btn">
                <a
                    href="javascript:void(0);"
                    @click.prevent="
                        $modal.show('m-filters', { organic: toggleOrganic, gluten: toggleGlutenFree, sale: toggleSale })
                    "
                >
                    <filter-svg></filter-svg>סינון
                </a>
            </div>
        </div>
        <section class="inner_page">
            <div class="container">
                <breadcrumbs :top="mainCategory" :sub="subCategory"></breadcrumbs>

                <div class="cat_inner row clearfix">
                    <div class="right side col-sm-2 col-xs-12" style="position: sticky; top: 150px">
                        <div class="side_wrap">
                            <div class="side_nav">
                                <div class="side_title">{{ mainCategory.name }}</div>
                                <div
                                    class="side_nav_link ease"
                                    v-bind:class="{ active: subcat.id === subCategory.id }"
                                    v-for="subcat in subCategories"
                                    :key="subcat.id"
                                >
                                    <router-link :to="{ path: subcat.link }">
                                        {{ subcat.name }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="side_filters">
                                <div class="side_title">סינון לפי:</div>
                                <div
                                    class="filter_check"
                                    v-bind:class="{ active: toggleWineRed }"
                                    v-if="subCategory.id == 56"
                                >
                                    <a href="javascript:void(0);" @click.prevent="showWineRed">יין אדום</a>
                                </div>
                                <div
                                    class="filter_check"
                                    v-bind:class="{ active: toggleWineWhite }"
                                    v-if="subCategory.id == 56"
                                >
                                    <a href="javascript:void(0);" @click.prevent="showWineWhite">יין לבן</a>
                                </div>
                                <div class="filter_check" v-bind:class="{ active: toggleSale }">
                                    <a href="javascript:void(0);" @click.prevent="showSale">במבצע</a>
                                </div>
                                <div class="filter_check" v-bind:class="{ active: toggleOrganic }">
                                    <a href="javascript:void(0);" @click.prevent="showOrganic">אורגני</a>
                                </div>
                                <div class="filter_check" v-bind:class="{ active: toggleGlutenFree }">
                                    <a href="javascript:void(0);" @click.prevent="showGlutenFree">ללא גלוטן</a>
                                </div>
                                <div class="filter_clean">
                                    <a href="javascript:void(0);" @click.prevent="clearFilters">ביטול סינונים</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="left main col-sm-10 col-xs-12">
                        <div class="m_row">
                            <h1 class="cat_title no_mobile">{{ subCategory.name }}</h1>
                            <banner-logo :sale="subCategory.sale" v-if="subCategory.sale" />
                        </div>
                        <div
                            class="sorry_row center"
                            v-if="typeof filteredList(products) != 'undefined' && filteredList(products).length == 0"
                        >
                            <div class="sorry_img">
                                <img :src="assets + '/layout/sorry.png'" />
                            </div>
                            <div class="title25 bold">
                                לצערנו, כאן אין לנו מוצרים
                                <br />שאתה מחפש
                            </div>
                            <div class="text">
                                אבל יש לנו עוד הרבה מוצרים {{ noProductsText }} אחרים שיוכלו למלא לך את העגלה בטוב
                            </div>
                            <div class="inline clearfix">
                                <div class="right bt_green ease" v-if="toggleSale">
                                    <a-div :href="globalOptions.all_sale_products_link.replace(home_url, '')"
                                        >לכל המוצרים במבצע</a-div
                                    >
                                </div>
                                <div class="right bt_green ease" v-if="toggleOrganic">
                                    <a-div :href="globalOptions.all_organic_products_link.replace(home_url, '')"
                                        >לכל המוצרים האורגניים</a-div
                                    >
                                </div>
                                <div class="right bt_green ease" v-if="toggleGlutenFree">
                                    <a-div :href="globalOptions.all_gluten_free_link.replace(home_url, '')"
                                        >לכל המוצרים ללא גלוטן</a-div
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="category_inner_prods grid row">
                            <div class="cat_group">
                                <Product
                                    ref="productComponent"
                                    v-bind:category="subCategory"
                                    v-bind:product="product"
                                    v-bind:index="index"
                                    v-for="(product, index) in filteredList(products)"
                                    :key="product.id"
                                    v-bind:shownumproducts="shownumproducts"
                                ></Product>
                            </div>
                        </div>
                        <div class="loader" v-if="showLoader">
                            <img :src="loaderGif" />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import Product from "../components/Product/Product";
    import BannerLogo from "../components/Banners/Sale";
    import FilterSvg from "../assets/img/filters.svg";
    import { mapGetters, mapState } from "vuex";
    import Breadcrumbs from "../components/Breadcrumbs";
    import MobileFilters from "../components/Popups/FilterMobilePopup";
    import Slick from "vue-slick";
    export default {
        data() {
            return {
                assets: wpData.assets_url,
                home_url: wpData.home_url,
                globalOptions: wpData.globalOptions,
                showLoader: false,
                shownumproducts: 40,
                loaderGif: wpData.assets_url + "/layout/loader.gif",
                toggleOrganic: false,
                toggleGlutenFree: false,
                toggleSale: false,
                toggleWineRed: false,
                toggleWineWhite: false,
                mSlickOptions: {
                    arrows: false,
                    rtl: true,
                    dots: false,
                    infinite: true,
                    centerMode: false,
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    autoplay: false,
                    autoplaySpeed: 3000,
                },
            };
        },
        watch: {
            $route(to, from) {
                this.toggleGlutenFree = false;
                this.toggleOrganic = false;
                this.toggleSale = false;
                this.toggleWineRed = false;
                this.toggleWineWhite = false;
            },
        },

        mounted() {
            this.$root.$on("filter", (event) => {
                this.toggleGlutenFree = event.gluten;
                this.toggleOrganic = event.organic;
                this.toggleSale = event.sale;
            });
            this.mSlickOptions.initialSlide = indexOfSlide;
            if ($(".side_wrap:visible").length > 0) {
                let topHeight = $("#header").outerHeight() + 50;
                let bottomHeight = $(".footer").outerHeight() + 50;
                $(".side_wrap").sticky({
                    topSpacing: topHeight,
                    bottomSpacing: bottomHeight,
                });
            }
        },
        created() {
            window.addEventListener("scroll", this.infiniteScroll);
        },
        destroyed() {
            window.removeEventListener("scroll", this.infiniteScroll);
        },
        beforeRouteUpdate(to, from, next) {
            this.shownumproducts = 40;
            next();
        },
        computed: {
            ...mapGetters(["productsByCat", "categoriesBySlug"]),
            ...mapState(["categories", "startCategory", "startProduct"]),
            noProductsText: function () {
                let txt = "";
                if (this.toggleSale) {
                    txt = "במבצע";
                }
                if (this.toggleOrganic) {
                    if (txt != "") {
                        txt = txt + " ו";
                    }
                    txt = txt + "אורגניים";
                }
                if (this.toggleGlutenFree) {
                    if (txt != "") {
                        txt = txt + " ו";
                    }
                    txt = txt + "ללא גלוטן";
                }
                return txt;
            },
            mainCategory: function () {
                let category = this.categories.find((c) => c.id == this.startCategory.parent);
                if (typeof category != "undefined") {
                    return category;
                }
                return false;
            },
            subCategory: function () {
                return this.startCategory;
                return false;
            },
            subCategories: function () {
                var subcat = this.$store.state.categories.filter((cat) => {
                    return cat.parent === this.mainCategory.id;
                });
                if (subcat) {
                    return subcat;
                }
                return false;
            },
            products: function () {
                var productsFound = this.productsByCat[this.subCategory.id];

                if (this.toggleOrganic) {
                    var organic = productsFound.filter((p) => {
                        //console.log(p.tags.includes(19));
                        if (p.tags.includes(19)) {
                            return p;
                        }
                    });
                    productsFound = organic;
                }
                if (this.toggleGlutenFree) {
                    var glutenfree = productsFound.filter((p) => {
                        if (p.tags.includes(18)) {
                            return p;
                        }
                    });
                    productsFound = glutenfree;
                }
                if (this.toggleSale) {
                    var sale = productsFound.filter((p) => {
                        if (p.onsale) {
                            return p;
                        }
                    });
                    productsFound = sale;
                }
                if (this.toggleWineRed) {
                    var redWine = productsFound.filter((p) => {
                        if (p.tags.includes(115)) {
                            return p;
                        }
                    });
                    productsFound = redWine;
                }
                if (this.toggleWineWhite) {
                    var whiteWine = productsFound.filter((p) => {
                        if (p.tags.includes(114)) {
                            return p;
                        }
                    });
                    productsFound = whiteWine;
                }
                this.toggleLoader();
                return productsFound;
            },
            productsLength: function () {
                if (typeof this.filteredList(this.products) != "undefined") {
                    return this.filteredList(this.products).length;
                }
                return 0;
            },
        },
        methods: {
            checkFilter(event) {},
            toggleLoader() {
                this.showLoader = false;
            },
            filteredList(items) {
                return items;
            },
            showOrganic() {
                if (this.toggleOrganic) {
                    this.toggleOrganic = false;
                    return;
                }
                this.toggleOrganic = true;
            },
            showGlutenFree() {
                if (this.toggleGlutenFree) {
                    this.toggleGlutenFree = false;
                    return;
                }
                this.toggleGlutenFree = true;
            },
            showWineRed() {
                if (this.toggleWineRed) {
                    this.toggleWineRed = false;
                    return;
                }
                this.toggleWineRed = true;
            },
            showWineWhite() {
                if (this.toggleWineWhite) {
                    this.toggleWineWhite = false;
                    return;
                }
                this.toggleWineWhite = true;
            },
            showSale() {
                if (this.toggleSale) {
                    this.toggleSale = false;
                    return;
                }
                this.toggleSale = true;
            },
            clearFilters() {
                this.toggleOrganic = false;
                this.toggleGlutenFree = false;
                this.toggleSale = false;
                this.toggleWineRed = false;
                this.toggleWineWhite = false;
            },
            showMoreProducts() {
                if (this.productsLength < this.shownumproducts) {
                    return false;
                }
                this.showLoader = true;

                setTimeout(() => {
                    this.showLoader = false;
                    this.shownumproducts += 20;
                }, 1000);
            },
            infiniteScroll() {
                var footer = document.getElementsByTagName("footer");

                var scrollHeightTest = footer[0].offsetTop - footer[0].offsetHeight - 500;
                if (window.pageYOffset >= scrollHeightTest) {
                    this.showMoreProducts();
                }
            },
        },
        components: {
            Product,
            Breadcrumbs,
            BannerLogo,
            FilterSvg,
            Slick,
            MobileFilters,
        },
    };
</script>
